import EditFieldBulkModal from "./EditFieldBulkModal";

export default EditFieldBulkModal;
